import { call, put, takeEvery } from 'redux-saga/effects'
import * as chamCongActions from '@redux/ducks/chamCong.Ducks'
import * as chamCongApi from '@apis/chamCong/chamCong.Api'
import * as viTriApi from '@apis/chamCong/viTri.Api'
import * as mangNoiBoApi from '@apis/chamCong/mangNoiBo.Api'
import * as caLamViecApi from '@apis/chamCong/caLamViec.Api'
import * as lichPhanCaApi from '@apis/chamCong/lichPhanCa.Api'
import * as mauCaApi from '@apis/chamCong/mauCa.Api'
import * as chiTietCongApi from '@apis/chamCong/chiTietCong.Api'
import * as tongHopCongApi from '@apis/chamCong/tongHopCong.Api'
import * as thongKeApi from '@apis/chamCong/thongKe.Api'

// Chấm công
function* fetchDanhSachChamCong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof chamCongApi.layLichSuChamCong> = yield call(chamCongApi.layLichSuChamCong, queryStr)
    yield put(chamCongActions.layDanhSachChamCongThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachChamCongThatBai(error))
  }
}

// Vị trí
function* fetchDanhSachViTri({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof viTriApi.locViTri> = yield call(viTriApi.locViTri, queryStr)
    yield put(chamCongActions.layDanhSachViTriThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachViTriThatBai(error))
  }
}

// Mạng nội bộ
function* fetchDanhSachMangNoiBo({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof mangNoiBoApi.locMangNoiBo> = yield call(mangNoiBoApi.locMangNoiBo, queryStr)
    yield put(chamCongActions.layDanhSachMangNoiBoThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachMangNoiBoThatBai(error))
  }
}

// Ca làm việc
function* fetchDanhSachCaLamViec({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof caLamViecApi.locCaLamViec> = yield call(caLamViecApi.locCaLamViec, queryStr)
    yield put(chamCongActions.layDanhSachCaLamViecThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachCaLamViecThatBai(error))
  }
}

// Lịch phân ca
function* fetchDanhSachLichPhanCa({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof lichPhanCaApi.locLichPhanCa> = yield call(lichPhanCaApi.locLichPhanCa, queryStr)
    yield put(chamCongActions.layDanhSachLichPhanCaThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachLichPhanCaThatBai(error))
  }
}

// Mẫu ca
function* fetchDanhSachMauCa({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof mauCaApi.locMauCa> = yield call(mauCaApi.locMauCa, queryStr)
    yield put(chamCongActions.layDanhSachMauCaThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachMauCaThatBai(error))
  }
}

// Chi tiết công
function* fetchDanhSachChiTietCong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof chiTietCongApi.locChiTietCong> = yield call(chiTietCongApi.locChiTietCong, queryStr)
    yield put(chamCongActions.layDanhSachChiTietCongThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachChiTietCongThatBai(error))
  }
}

// Tổng hợp công
function* fetchDanhSachTongHopCong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof tongHopCongApi.locTongHopCong> = yield call(tongHopCongApi.locTongHopCong, queryStr)
    yield put(chamCongActions.layDanhSachTongHopCongThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachTongHopCongThatBai(error))
  }
}

// Thống kê
function* fetchDanhSachThongKe({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof thongKeApi.layThongKeChamCong> = yield call(thongKeApi.layThongKeChamCong, queryStr)
    yield put(chamCongActions.layDanhSachThongKeThanhCong(res))
  } catch (error) {
    yield put(chamCongActions.layDanhSachThongKeThatBai(error))
  }
}

export default function* watchChamCong() {
  yield takeEvery(chamCongActions.layDanhSachChamCong.toString(), fetchDanhSachChamCong)
  yield takeEvery(chamCongActions.layDanhSachViTri.toString(), fetchDanhSachViTri)
  yield takeEvery(chamCongActions.layDanhSachMangNoiBo.toString(), fetchDanhSachMangNoiBo)
  yield takeEvery(chamCongActions.layDanhSachCaLamViec.toString(), fetchDanhSachCaLamViec)
  yield takeEvery(chamCongActions.layDanhSachLichPhanCa.toString(), fetchDanhSachLichPhanCa)
  yield takeEvery(chamCongActions.layDanhSachMauCa.toString(), fetchDanhSachMauCa)
  yield takeEvery(chamCongActions.layDanhSachChiTietCong.toString(), fetchDanhSachChiTietCong)
  yield takeEvery(chamCongActions.layDanhSachTongHopCong.toString(), fetchDanhSachTongHopCong)
  yield takeEvery(chamCongActions.layDanhSachThongKe.toString(), fetchDanhSachThongKe)
}

